import * as React from 'react';

export interface EcsSettings {
    useMeetingsApi: boolean;
    useUnifiedView: boolean;
    useJoinThread?: boolean;
    maxRetries?: number;
    allowDesktopSafariGuestFlow?: boolean;
    webSubdomainForRedirect?: string;
}

export interface EcsContext {
    settings: EcsSettings;
}

const context = React.createContext<EcsContext>({} as EcsContext);

export const EcsContextProvider = context.Provider;

export const EcsContextConsumer = context.Consumer;
